/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Read_Along_Ai_FallbacksInputs */

const en_read_along_ai_fallbacks = /** @type {(inputs: Read_Along_Ai_FallbacksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Model switches: ${i?.count}`)
};

const es_read_along_ai_fallbacks = /** @type {(inputs: Read_Along_Ai_FallbacksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambios de modelo: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Model switches: {count}" |
*
* @param {Read_Along_Ai_FallbacksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_fallbacks = /** @type {((inputs: Read_Along_Ai_FallbacksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_FallbacksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_fallbacks(inputs)
	return en_read_along_ai_fallbacks(inputs)
});